import { render, staticRenderFns } from "./MenuLayoutWidgets.vue?vue&type=template&id=6f318846"
import script from "./MenuLayoutWidgets.vue?vue&type=script&lang=js"
export * from "./MenuLayoutWidgets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports